<template lang="">
  <div class="loading-component" v-if="isLoading">
    <h1 class="title">
      <template v-if="!isLogin">
        just few seconds ..
        <span>
          {{ userName }}
        </span>
      </template>
      <template v-else>
        <span>please wait ..</span>
      </template>
    </h1>

    <div class="lds-roller">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["UserModule"]),
    isLoading() {
      return this.$store.state.loading;
    },
    isLogin(){
      return this.$route.name === 'login'
    },
    userName(){
      return this.$store.state.name
    },
  },
};
</script>
<style lang="css" scoped>
.loading-component {
  position: fixed;
  z-index: 99999999999;
  background: rgb(var(--body-bg-color));
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.title {
  font-family: "Edu TAS Beginner", cursive;
  font-weight: 600;
  text-align: center;
  font-size: 1.7rem;
  text-transform: capitalize;
  color: rgb(var(--sec-font-color));
}
@media screen and ( max-width:590px  ) {
  .title{
    font-size: 1rem;
  }
  .title span{
    font-size: 2rem;
  }
  
}
.title span {
  font-size: 3rem;
  font-weight: normal;
}
.lds-roller {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-roller div {
  animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 40px 40px;
}
.lds-roller div:after {
  content: " ";
  display: block;
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: rgb(var(--sec-font-color));
  margin: -4px 0 0 -4px;
}
.lds-roller div:nth-child(1) {
  animation-delay: -0.036s;
}
.lds-roller div:nth-child(1):after {
  top: 63px;
  left: 63px;
}
.lds-roller div:nth-child(2) {
  animation-delay: -0.072s;
}
.lds-roller div:nth-child(2):after {
  top: 68px;
  left: 56px;
}
.lds-roller div:nth-child(3) {
  animation-delay: -0.108s;
}
.lds-roller div:nth-child(3):after {
  top: 71px;
  left: 48px;
}
.lds-roller div:nth-child(4) {
  animation-delay: -0.144s;
}
.lds-roller div:nth-child(4):after {
  top: 72px;
  left: 40px;
}
.lds-roller div:nth-child(5) {
  animation-delay: -0.18s;
}
.lds-roller div:nth-child(5):after {
  top: 71px;
  left: 32px;
}
.lds-roller div:nth-child(6) {
  animation-delay: -0.216s;
}
.lds-roller div:nth-child(6):after {
  top: 68px;
  left: 24px;
}
.lds-roller div:nth-child(7) {
  animation-delay: -0.252s;
}
.lds-roller div:nth-child(7):after {
  top: 63px;
  left: 17px;
}
.lds-roller div:nth-child(8) {
  animation-delay: -0.288s;
}
.lds-roller div:nth-child(8):after {
  top: 56px;
  left: 12px;
}
@keyframes lds-roller {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
